//@flow
import React from 'react';
import modal from '../../Modal/components/StandardModal.react';
import UrlData from '../../Utils/url-data';
import Constants from '../../constants';

import type MembershipModel from '../../Stores/Membership/membershipModel';
import type { ModalProps } from '../../Modal/components/StandardModal.react';

type Props = {
  membership:MembershipModel,
};

function _closeModal(props:Props) {
  let rerouteUrl = '/checkout/shipping';
  if (props.membership.isReturningMember()) rerouteUrl = '/checkout/confirm';
  UrlData.setCurrentUrl(`${rerouteUrl}?hideAmazon=true`);
}

function AmazonCheckoutErrorModal(props:ModalProps&Props) {
  return (
    <div>
      <h2>OOPS!</h2>
      <p>It looks like Amazon Pay isn’t working at the moment. Please enter your shipping and payment info to complete checkout.</p>
      <button onClick={props.close} className="cta-large">Back to checkout</button>
    </div>
  );
}

export default modal<Props>(AmazonCheckoutErrorModal, {
  name: Constants.AMAZON_CHECKOUT_ERROR_MODAL,
  className: 'error-modal',
  close: _closeModal,
});
